import React, { useEffect, useMemo } from "react"
import ImageCarousel from "@components/product/gallery"
import BundleAddToCart from "@components/cart/bundle-add-to-cart"
import ProductDetails from "@src/components/product/details"
import { useProductStore } from "@src/hooks/useStore"

const filterVariants = (product, variants, hiddenVariants) => {
  return (
    variants
      ?.filter(
        variant =>
          !hiddenVariants?.find(
            hiddenVariant => hiddenVariant._id === variant._id
          )
      )
      ?.map(variant => ({ ...variant, productId: product?.shopifyId })) || []
  )
}

const EmbeddedProductView = ({ product, hiddenVariants }) => {
  if (!product) {
    return null
  }

  const { bundleProductsList, isBundle, layout, bundleImages } = product

  const { setCurrentVariant } = useProductStore(["setCurrentVariant"])

  const filteredVariants = useMemo(() => {
    return filterVariants(product, product.variants, hiddenVariants)
  }, [product.variants, product.shopifyId, hiddenVariants])

  const initialVariant = useMemo(() => filteredVariants[0], [filteredVariants])

  const initialImages =
    isBundle && layout !== "product"
      ? bundleImages
      : initialVariant?.variantImages

  useEffect(() => {
    if (!isBundle) {
      setCurrentVariant(initialVariant)
    }
  }, [isBundle])

  return (
    <div className="grid grid-cols-12 gap-5">
      <div className="col-span-12 md:col-span-7 image-carousel-column">
        <ImageCarousel
          productEntry={product}
          initialImages={initialImages}
          overrideImages={initialImages}
          variantImages={initialVariant?.variantImages}
          listingImage={initialVariant?.listingImage}
          ignoreGlobalImages
        />
      </div>
      <div className="col-span-12 md:col-span-5 text-left">
        {isBundle ? (
          <BundleAddToCart
            {...{
              bundleProductsList: bundleProductsList.map(bundle => ({
                ...bundle,
                variants: filterVariants(
                  bundle,
                  bundle.variants,
                  hiddenVariants
                ),
                crossSell: [],
              })),
              productEntry: {
                ...product,
                variants: filteredVariants,
                crossSell: [],
              },
              mainLayout: product?.layout,
            }}
          />
        ) : (
          <ProductDetails
            productEntry={{
              ...product,
              variants: filteredVariants,
              crossSell: [],
            }}
            productOptions={product?.productOptions}
          />
        )}
      </div>
    </div>
  )
}

export default EmbeddedProductView
